module.exports = "/build/web/svg/social/facebook.85e97d28c97fb4adfcd1aa7500571052.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/facebook.svg
// module id = 189
// module chunks = 24